(function () {
  const toc = document.querySelector('[data-article-toc]');
  if (!toc) return;

  const content = document.querySelector(toc.dataset.contentSelector || '.article-template__content');
  if (!content) return;

  const headings = content.querySelectorAll('h2');
  if (!headings.length) return;

  const list = toc.querySelector('[data-article-toc-list]');
  if (!list) return;

  const slugCounts = {};
  headings.forEach(function (heading) {
    if (!heading.id) {
      let slug = heading.textContent
        .trim()
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
      if (!slug) slug = 'section';
      if (slugCounts[slug]) {
        slugCounts[slug] += 1;
        slug = slug + '-' + slugCounts[slug];
      } else {
        slugCounts[slug] = 1;
      }
      heading.id = slug;
    }

    const item = document.createElement('li');
    item.className = 'article-toc__item';
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    link.className = 'article-toc__link link';
    item.appendChild(link);
    list.appendChild(item);
  });

  toc.hidden = false;
})();
